import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UseConditionsConfig } from '@shared/config/use-conditions.config';

@Injectable({
  providedIn: 'root',
})
export class UseConditionsService {
  constructor(private http: HttpClient) {}

  validateCgu(formGroup: any): Observable<any> {
    const cguData = {
      isTerms: formGroup.value.checkbox1,
      isCggc: formGroup.value.checkbox2,
      isPrivacies: formGroup.value.checkbox3
    };

    return this.http
      .put<any>(`${UseConditionsConfig.valideCgu}`, cguData, { responseType: 'text' as 'json' })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          throw error;
        }),
      );
  }
}
